import usersLoginReducer from './user-login.reducers'
import usersProfileReducer from './user-profile.reducers'

export { usersLoginReducer, usersProfileReducer }
